import type {RtcLogger} from '@phonehq/rtc-core';

export const watchClientEnvironment = (logger: RtcLogger, target: Window = window): (() => void) => {
    const onVisibility = () => logger.info('rtc.client.visibility', {state: target.document.visibilityState});
    const onOnline = () => logger.info('rtc.client.network', {state: 'online'});
    const onOffline = () => logger.warn('rtc.client.network', {state: 'offline'});
    target.document.addEventListener('visibilitychange', onVisibility);
    target.addEventListener('online', onOnline);
    target.addEventListener('offline', onOffline);
    return () => {
        target.document.removeEventListener('visibilitychange', onVisibility);
        target.removeEventListener('online', onOnline);
        target.removeEventListener('offline', onOffline);
    };
};
